// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"ed253f18","146":"d2430184","315":"83d2b010","419":"7c227053"}[chunkId] + ".css";
};